export const USERINFO = "UserInfo";
export const ROOMINFO = "RoomInfo";
export const WECHATUSERINFO = "wechatUserInfo";
export const COMPANYCODE = "companyCode";
export const RESTARUANTINFO = "restaruantInfo";
